import React, { useEffect } from "react";

import { SEARCH_KEY } from "fond/constants";
import SearchResults from "fond/projects/GlobalSearch/SearchResults";
import { Navigation } from "fond/projects/Navigation";
import RecentContent from "fond/projects/RecentContent";
import { updateFilter } from "fond/projects/redux";
import { useAppDispatch, useQueryParams } from "fond/utils/hooks";
import { PageContent } from "fond/widgets";

/**
 * A top level component used for displaying recent projects.
 */
const Recent: React.FC = () => {
  const dispatch = useAppDispatch();

  // Clear filter
  useEffect(() => {
    dispatch(updateFilter(null));
  }, [dispatch]);

  // Global search results page
  const searchQuery = useQueryParams(SEARCH_KEY);
  if (searchQuery) {
    return <SearchResults />;
  }

  return <PageContent title="Recent" mainContent={<RecentContent />} navigation={<Navigation />} testId="filter-recent" />;
};

export default Recent;
